import { useFormContext } from "react-hook-form";

import { InputDateControllerRow, InputTextRow } from "@components";

import {
  BASIC_INFO,
  ResignationFormDataType,
} from "@validations/HRM/resignation/resignationFormValidation";

export const BasicInfo = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<ResignationFormDataType>();

  return (
    <div className="d-flex flex-column gap-10 pb-10">
      <InputTextRow
        label="RESIGNATION.FORM.BASIC_INFO.NAME"
        register={{ ...register(BASIC_INFO.NAME) }}
        error={errors as any}
        disabled
      />
      <InputTextRow
        label="RESIGNATION.FORM.BASIC_INFO.CURRENT_POSTING"
        register={{ ...register(BASIC_INFO.CURRENT_POSTING) }}
        error={errors as any}
        disabled
      />
      <InputDateControllerRow
        label="RESIGNATION.FORM.BASIC_INFO.RESIGNATION_DATE"
        control={control}
        register={{ ...register(BASIC_INFO.RESIGNATION_DATE) }}
        errors={errors as any}
        name={BASIC_INFO.RESIGNATION_DATE}
        required
      />
    </div>
  );
};
